export default function ({ store, route, redirect, res }) {
  const auth = store.state.auth;

  if (!auth.is_admin) {
    const user_permissions = auth.permissionNames;

    const is_pass = route.meta.some((meta) => {
      if (meta.user_permission_names !== undefined) {
        return collect(meta.user_permission_names).diff(user_permissions).count() == 0
      }

      return false
    });

    if (!is_pass) {
     return redirect('/panel');
    }
  }
}
